import type { BlurLevel } from 'devices/types';

/**
 * Writes the background choice to the two keys `initialUserState` rehydrates from.
 *
 * Shared so every path that changes the choice persists it identically — a path that updates only
 * the slice leaves `localStorage` holding a stale value that comes back on the next page load.
 */
export const persistVideoBackgroundSettings = ({
  blurLevel,
  backgroundImageId,
}: {
  blurLevel: BlurLevel;
  backgroundImageId: string;
}) => {
  localStorage.setItem('blurLevel', blurLevel.toString());
  localStorage.setItem('backgroundImageId', backgroundImageId);
};
